module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/p-today-720.2e413a08c3768d00.png"+" 720w",
        images: [{path: "https://static.sniffspot.com/packs/img/p-today-720.2e413a08c3768d00.png",width: 720,height: 111}],
        src: "https://static.sniffspot.com/packs/img/p-today-720.2e413a08c3768d00.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/p-today-720.2e413a08c3768d00.png"},
        
        width: 720,
        height: 111
      }